<i18n>
{
  "en": {
    "CreativeDemoTitle": "Swan Ballettschule Nadine Boehm"
  },
  "de": {
    "CreativeDemoTitle": "Swan Ballettschule Nadine Boehm"
  }
}
</i18n>
<template>
  <embed-viewer-route-view
    :url="'https://www.google.com/maps/embed?pb=!4v1546378196341!6m8!1m7!1sCAoSLEFGMVFpcE9TZWpnSFpEbEIzRDhxNzNLUENLeC1EWnRnQV9ZZUJHOXBGclRG!2m2!1d47.2703646437219!2d8.44201210877759!3f218.28153636296267!4f-1.837714194014481!5f0.7820865974627469'"
    :title="$t('CreativeDemoTitle')"
    :can-go-back="canGoBack"
  ></embed-viewer-route-view>
</template>
<script>
export default {
  data() {
    return {
      canGoBack: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = !!from.name;
    });
  }
};
</script>